import { serializable, deserialize, custom } from 'serializr';
import { Base } from './base.model';
import { Deserializable } from './deserializable';
import { TestCase } from '@modules/test-development/models/test-case.model';

export class SuiteTestCaseMappings extends Base implements Deserializable {
  @serializable
  public suiteId: number;
  @serializable(
    custom(
      (v) => {
        if (v) return v.serialize();
      },
      (v) => {
        if (v) {
          return new TestCase().deserialize(v);
        }
      },
    ),
  )
  public testCase: TestCase;
  @serializable
  public position: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SuiteTestCaseMappings, input));
  }
}
